function inWords (timeObj, that) {
  const daysInWords = timeObj.d === '0' ? '' : `${parseInt(timeObj.d)} ${days(timeObj.d, that)}`
  const hoursInWords = timeObj.h === '00' ? '' : `${parseInt(timeObj.h)} ${hours(timeObj.h, that)}`
  const minutesInWords = timeObj.m === '00' ? '' : `${parseInt(timeObj.m)} ${minutes(timeObj.m, that)}`
  const secondsInWords = timeObj.s === '00' ? '' : `${parseInt(timeObj.s)} ${seconds(timeObj.s, that)}`
  return `${daysInWords} ${hoursInWords} ${minutesInWords} ${secondsInWords}`
}

function inMinutesAndSeconds (timeObj, that) {
  let minutes = timeObj.m === '00' ? 0 : `${parseInt(timeObj.m)}`
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  let seconds = timeObj.s === '00' ? 0 : `${parseInt(timeObj.s)}`
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${minutes}:${seconds}`
}

function inHoursMinutesAndSeconds (timeObj, that) {
  const days = timeObj.d ? parseInt(timeObj.d) : 0
  let hours = `${days * 24 + parseInt(timeObj.h)}`
  if (hours < 10) {
    hours = `0${hours}`
  }
  let minutes = timeObj.m === '00' ? 0 : `${parseInt(timeObj.m)}`
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  let seconds = timeObj.s === '00' ? 0 : `${parseInt(timeObj.s)}`
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${hours}:${minutes}:${seconds}`
}

function inShortWords (timeObj, that) {
  return inWords(timeObj, that)
}

function inSuperShortWords (timeObj, that) {
  return inWords(timeObj, that)
}

function days (v, that) {
  if (parseInt(v) === 1) {
    return that?.$t ? that.$t('countdown.day') : 'Tag'
  } else {
    return that?.$t ? that.$t('countdown.days') : 'Tagen'
  }
}

function hours (v, that) {
  if (parseInt(v) === 1) {
    return that?.$t ? that.$t('countdown.hour') : 'Stunde'
  } else {
    return that?.$t ? that.$t('countdown.hours') : 'Stunden'
  }
}

function minutes (v, that) {
  if (parseInt(v) === 1) {
    return that?.$t ? that.$t('countdown.minute') : 'Minute'
  } else {
    return that?.$t ? that.$t('countdown.minutes') : 'Minuten'
  }
}

function seconds (v, that) {
  if (parseInt(v) === 1) {
    return that?.$t ? that.$t('countdown.second') : 'Sekunde'
  } else {
    return that?.$t ? that.$t('countdown.seconds') : 'Sekunden'
  }
}

function parseDate (date) {
  let d
  if (date) {
    d = Date.parse(date)
  }

  if (!isNaN(d)) {
    return d
  }

  return undefined
}

const time = {
  days,
  hours,
  minutes,
  seconds,
  inWords,
  inShortWords,
  inSuperShortWords,
  parseDate,
  inMinutesAndSeconds,
  inHoursMinutesAndSeconds

}

export default time
